import { TYPE } from '../../constants'
import { GtmTakeAwardClickModel } from '../../models'
import { BaseBuilder } from '../base.builder/base.builder'

export class TakeAwardClickBuilder extends BaseBuilder {
  constructor(data) {
    const models = new Map([[TYPE.GTM_4, GtmTakeAwardClickModel]])
    super(models, data)
  }
}
